import React, { useState, useEffect } from "react";
import "./CardProfile.css";
import { capitalizeFirstLetter } from "../../utils/stringUtils";
import { convertMana } from "../../utils/manaConverter";

const CardProfile = ({ card, onClose }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [manaSymbols, setManaSymbols] = useState([""]);

  const isDoubleFaced = card.card_faces?.length === 2;

  const currentFace =
    isFlipped && isDoubleFaced
      ? card.card_faces[1]
      : card.card_faces?.[0] || card;

  const frontImage =
    card.image_uris?.normal || card.card_faces?.[0]?.image_uris?.normal;
  const backImage = card.card_faces?.[1]?.image_uris?.normal;

  const rarity = card.rarity;
  const setName = card.set_name;
  const artist = card.artist;

  const manaCost = currentFace.mana_cost;
  const typeLine = currentFace.type_line;
  const oracleText = currentFace.oracle_text;
  const flavorText = currentFace.flavor_text;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  useEffect(() => {
    convertMana(manaCost, setManaSymbols);
  }, [manaCost]);

  return (
    <div className="card-profile-backdrop" onClick={onClose}>
      <div className="card-profile" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <div className="card-profile-content">
          {/* LEFT SIDE */}
          <div className="card-profile-left">
            <div className="card-image-block">
              <div
                className={`card-flip-container ${isFlipped ? "flipped" : ""}`}
              >
                <div className="card-flip-inner">
                  <div className="card-face front">
                    <img src={frontImage} alt={`${card.name} front`} />
                  </div>
                  {isDoubleFaced && (
                    <div className="card-face back">
                      <img src={backImage} alt={`${card.name} back`} />
                    </div>
                  )}
                </div>
                {isDoubleFaced && (
                  <img
                    src={`${process.env.PUBLIC_URL}/cycle.png`}
                    alt="Flip card"
                    className="profile-flip-icon"
                    onClick={() => setIsFlipped((prev) => !prev)}
                  />
                )}
              </div>
            </div>

            <p className="card-actions-placeholder">Coming soon...</p>
            <div className="card-actions">
              <button className="action-btn">Add to Deck</button>
              <button className="action-btn">Save as Proxy</button>
              <button className="action-btn">Favorite</button>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="card-profile-right">
            {card.name.includes("//") ? (
              <h2 className="card-name-title">
                {card.name.split("//")[0].trim()}
                <br />
                <span className="card-profile-name-secondary">
                  {card.name.split("//")[1].trim()}
                </span>
              </h2>
            ) : (
              <h2 className="card-name-title">{card.name}</h2>
            )}
            <p className="card-meta">
              {capitalizeFirstLetter(rarity)} — {setName}
            </p>
            <div className="mana-row">{manaSymbols}</div>
            <p className="type-line">{typeLine}</p>
            <p className="card-oracle-text">{oracleText}</p>
            {flavorText && <p className="flavor-text">"{flavorText}"</p>}
            <p className="artist-text">Art by {artist}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardProfile;
